<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>
      <template v-for="(item, index) in sideBarItems">
        <sidebar-link
          :to="item.link"
          v-bind:key="index"
          v-if="
            userPermissions.includes(item.permission) ||
            item.permission === 'entity'
          "
        >
          <!-- <md-list v-if="item.items != null" :md-expand-single="expandSingle" class="removePadding">
            <md-list-item md-expand>
              <md-icon>{{item.icon}}</md-icon>
              <p>{{item.title}}</p>
              <md-list slot="md-expand">
                <template v-for="(i, indexs) in item.items">
                  <sidebar-link
                    :to="item.link"
                    v-bind:key="indexs"
                  >
                    <md-list-item class="md-inset">
                      <p>{{i.title}}</p>
                    </md-list-item>
                  </sidebar-link>
                </template>
              </md-list>
            </md-list-item>
          </md-list>
          <template v-else> -->
          <md-icon>{{ item.icon }}</md-icon>
          <p>{{ item.title }}</p>
          <!-- </template> -->
        </sidebar-link>
      </template>
      <!-- <v-footer padless absolute style="background-color: transparent"> -->
      <!-- <i class="md-icon md-icon-font md-theme-default">logout</i>
          <p class="white--text">Logout</p> -->
      <!-- <v-btn tile block color="grey darken-1"  @click="logout()" class="white--text">
          <md-icon>logout</md-icon>
          <span>Logout</span>
        </v-btn> -->
      <!-- <sidebar-link to="#" @click="logout()" style="width: 100%">
          <md-icon>logout</md-icon>
          <p>Logout</p>
        </sidebar-link> -->
      <!-- <md-icon>logout</md-icon>
        <span class="white--text" @click="logout()">Logout</span> -->
      <!-- </v-footer> -->
      <!-- <mobile-menu slot="content"></mobile-menu> -->
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content></dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import { mapActions, mapGetters } from "vuex";
import orderBy from "lodash/orderBy";
import includes from "lodash/includes";
import { userHaveRoles } from "@/services/utilities";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
  },
  data() {
    return {
      expandSingle: true,
      sideBarItems: [
        {
          link: "/company",
          icon: "person",
          title: "Company Profile",
          permission: "Read Company",
          items: null,
        },
        {
          link: "/manage-user",
          icon: "people",
          title: "Manage User",
          permission: "Read Users",
          items: null,
        },
        {
          link: "/pemasukan",
          icon: "attach_money",
          title: "Pemasukan",
          permission: "Read Company",
          items: [
            {
              link: "/belanja",
              icon: "attach_money",
              title: "Belanja",
            },
          ],
        },
        {
          link: "/pengeluaran",
          icon: "shopping_basket",
          title: "Pengeluaran",
          permission: "Read Company",
          items: null,
        },
        {
          link: "/produk",
          icon: "store_mall_directory",
          title: "Produk",
          permission: "Read Products",
          items: null,
        },
        {
          link: "/layanan",
          icon: "build",
          title: "Jadwal Layanan",
          permission: "Read Layanan",
          items: null,
        },
        {
          link: "/items",
          icon: "storefront",
          title: "Items",
          permission: "Read Items",
          items: null,
        },
        {
          link: "/transaction",
          icon: "compare_arrows",
          title: "Daftar Transaksi",
          permission: "Read Transactions",
          items: null,
        },
        {
          link: "/settings",
          icon: "settings",
          title: "Settings",
          permission: "Settings",
          items: null,
        },
        {
          link: "/product-interface",
          icon: "eye",
          title: "Interfaces",
          permission: "Settings",
        },

        // {
        //   link: "/belanja",
        //   icon: "shopping_cart",
        //   title: "Belanja",
        //   permission: "Read Belanja",
        //   items: null
        // },
        {
          link: "/settings-maksimum-submissions",
          icon: "settings",
          title: "Maksimum Submissions",
          permission: "Settings Maksimum Submissions",
          items: null,
        },
        {
          link: "/wallet",
          icon: "credit_card",
          title: "Wallet",
          permission: "Read Metode Pembayaran",
          items: null,
        },
        {
          link: "/kategori-submission",
          icon: "settings",
          title: "Kategori Submission",
          permission: "Read Company",
          items: null,
        },
        {
          link: "/kategori-produk",
          icon: "settings",
          title: "Kategori Produk",
          permission: "Read Company",
          items: null,
        },
        {
          link: "/notifikasi",
          icon: "notifications",
          title: "Notifikasi",
          permission: "Read Notification",
          items: null,
        },
        {
          link: "/laporan",
          icon: "print",
          title: "Laporan",
          permission: "Read Laporan",
          items: null,
        },
         {
          link: "/broadcast",
          icon: "podcasts",
          title: "Broadcast",
          permission: userHaveRoles(["entity"]) ? "entity" : "",
          items: null,
        },
        {
          link: "/api-keys",
          icon: "vpn_key",
          title: "API Keys",
          permission: userHaveRoles(["entity"]) ? "entity" : "",
          items: null,
        },
      ],
      userPermissions: [],
    };
  },
  computed: {
    ...mapGetters({}),
  },
  created() {
    const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
    this.userPermissions = userLogin.permissions;
    // this.role = userLogin.role.name
    // await this.getCompany()
    // this.editedValue = isEmpty(this.companyData) ? this.editedValue : Object.assign({}, this.companyData)
    // this.defaultValue = Object.assign({}, this.editedValue)
  },
  mounted() {
    // const response = await this.getUser
    // const permission = orderBy(response.data.attributes.permission, ['id'], ['asc'])
    // for(const role of permission){
    //   const sideBarItem = {
    //     link: role.link,
    //     icon: role.icon,
    //     title: role.name
    //   }
    //   this.sideBarItems.push(sideBarItem)
    // }
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
      getUser: "auth/getUserData",
    }),
    async initialize() {
      // for(const role of response.data.attributes.permission){
      //   const sideBarItem = {
      // 	link: role.link,
      // 	icon: role.icon,
      // 	title: role.name
      //   }
      //   this.sideBarItems.push(sideBarItem)
      // }
    },
    logout() {
      let result = confirm("Are you sure you want to logout?");
      if (result) {
        this.logOut();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$list-width: 320px;

.full-control {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap-reverse;
}

.list {
  width: $list-width;
}

.full-control > .md-list {
  width: $list-width;
  max-width: 100%;
  height: 400px;
  display: inline-block;
  overflow: auto;
  border: 1px solid rgba(#000, 0.12);
  vertical-align: top;
}

.control {
  min-width: 250px;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.removePadding {
  padding: 0px !important;
}

// .div > .md-list-item-content > .md-ripple{
//   padding: 0px !important;
// }
</style>
